(() => {
  if (!window.noraviroSaleRemaining) {
    window.noraviroSaleRemaining = (() => {
      const key = 'noraviro-sale-deadline-v1';
      const duration = 5313000;
      let deadline;
      return () => {
        const now = Date.now();
        try {
          const saved = Number(localStorage.getItem(key));
          if (Number.isFinite(saved) && saved > 0) deadline = saved;
        } catch {}
        if (!Number.isFinite(deadline) || deadline <= 0) {
          deadline = now + duration;
          try { localStorage.setItem(key, String(deadline)); } catch {}
        }
        if (now >= deadline) {
          deadline = now + duration;
          try { localStorage.setItem(key, String(deadline)); } catch {}
          return 0;
        }
        return Math.ceil((deadline - now) / 1000);
      };
    })();
  }
  function initialize(root) {
    if (root.dataset.nvInitialized) return;
    root.dataset.nvInitialized = 'true';
    root.querySelectorAll('[data-thumbnail]').forEach(button => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-slide]').forEach(slide => { slide.hidden = slide.dataset.slide !== button.dataset.thumbnail; });
        root.querySelectorAll('[data-thumbnail]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
    const sale = root.querySelector('[data-nv-sale]');
    let saleTimer;
    if (sale) {
      const tick = () => {
        const left = window.noraviroSaleRemaining();
        sale.querySelector('[data-hours]').textContent = String(Math.floor(left / 3600)).padStart(2, '0');
        sale.querySelector('[data-minutes]').textContent = String(Math.floor(left / 60) % 60).padStart(2, '0');
        sale.querySelector('[data-seconds]').textContent = String(left % 60).padStart(2, '0');
      };
      saleTimer = setInterval(tick, 1000);
      tick();
    }
    const submit = root.querySelector('[data-nv-submit]');
    const variantInput = root.querySelector('[data-cart-variant]');
    const planInput = root.querySelector('[data-cart-plan]');
    const labels = JSON.parse(root.querySelector('[data-nv-labels]').textContent);
    function selectOffer() {
      const chosen = root.querySelector('input[type="radio"]:checked');
      if (!chosen) return;
      const savings = root.querySelector('[data-order-savings]');
      const shipping = root.querySelector('[data-order-shipping]');
      const total = root.querySelector('[data-order-total]');
      if (savings) savings.textContent = chosen.dataset.savings;
      if (shipping) shipping.textContent = chosen.dataset.shipping;
      if (total) total.textContent = chosen.dataset.total;
      root.querySelectorAll('[data-gift]').forEach(gift => {
        const included = Number(gift.dataset.gift) <= Number(chosen.dataset.gifts);
        gift.classList.toggle('nv-gift--excluded', !included);
        const status = included ? labels.included : (Number(gift.dataset.gift) === 2 ? labels.buy2 : labels.buy3);
        gift.querySelector('[data-gift-status]').textContent = status;
        gift.querySelector('[data-gift-badge-label]').textContent = included ? gift.dataset.freeLabel : status;
      });
      const ready = chosen.dataset.ready === 'true' && Boolean(chosen.dataset.variant) && Boolean(chosen.dataset.sellingPlan);
      submit.disabled = !ready;
      variantInput.disabled = !ready;
      variantInput.value = ready ? chosen.dataset.variant : '';
      planInput.disabled = !ready;
      planInput.value = ready ? chosen.dataset.sellingPlan : '';
      submit.textContent = ready ? `${submit.dataset.activeLabel} — ${chosen.closest('.nv-offer').querySelector('.nv-offer-price').firstChild.textContent.trim()}` : submit.dataset.pendingLabel;
    }
    root.querySelectorAll('input[type="radio"]').forEach(input => input.addEventListener('change', selectOffer));
    const cartForm = root.querySelector('[data-nv-cart]');
    let adding = false;
    cartForm.addEventListener('submit', async event => {
      event.preventDefault();
      if (adding || submit.disabled || !variantInput.value) return;
      const errorMessage = cartForm.querySelector('[data-cart-error]');
      errorMessage.hidden = true;

      adding = true;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.textContent = submit.dataset.loadingLabel;
      try {
        const cartResponse = await fetch(cartForm.dataset.cartUrl, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error(submit.dataset.errorLabel);
        let cart = await cartResponse.json();
        const chosen = root.querySelector('input[type="radio"]:checked');
        const giftIds = (chosen.dataset.giftVariants || '').split(',').filter(Boolean);
        const bottleIds = ['61727939985548', '62511756869772', '62511756935308', '62766220378252', '62766220411020','63509444231308','63509444264076','63509444296844'];
        const allGiftIds = new Set(Array.from(root.querySelectorAll('input[type="radio"]'))
          .flatMap(input => (input.dataset.giftVariants || '').split(',').filter(Boolean)));
        const bundleLines = cart.items.filter(item => bottleIds.includes(String(item.variant_id)) ||
          (allGiftIds.has(String(item.variant_id)) && !item.selling_plan_allocation && item.final_line_price === 0));
        if (bundleLines.length) {
          const updatedResponse = await fetch(cartForm.dataset.cartUpdateUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: Object.fromEntries(bundleLines.map(item => [item.key, 0])) })
          });
          if (!updatedResponse.ok) throw new Error(submit.dataset.errorLabel);
          cart = await updatedResponse.json();
        }
        const existingProgram = cart.items.filter(item => String(item.variant_id) === cartForm.dataset.programVariant);
        if (existingProgram.some(item => String(item.selling_plan_allocation?.selling_plan?.id) !== cartForm.dataset.programPlan || item.quantity !== 1) || existingProgram.length > 1) throw new Error(submit.dataset.errorLabel);
        const bottleQuantity = Number(chosen.dataset.bottleQuantity);
        if (![1, 2, 3].includes(bottleQuantity)) throw new Error(submit.dataset.errorLabel);
        const items = [{ id: variantInput.value, quantity: bottleQuantity, selling_plan: planInput.value }];
        if (!existingProgram.length) items.push({ id: cartForm.dataset.programVariant, quantity: 1, selling_plan: cartForm.dataset.programPlan });
        for (const id of giftIds) {
          const existingGift = cart.items.filter(item => String(item.variant_id) === id);
          if (existingGift.length > 1 || existingGift.some(item => item.quantity !== 1 || item.selling_plan_allocation)) throw new Error(submit.dataset.errorLabel);
          if (!existingGift.length) items.push({ id, quantity: 1 });
        }
        const response = await fetch(`${cartForm.action}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error(result.description || submit.dataset.errorLabel);
        }
        const pricedResponse = await fetch(cartForm.dataset.cartUpdateUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: chosen.dataset.discountCode || '' })
        });
        if (!pricedResponse.ok) throw new Error(submit.dataset.errorLabel);
        const pricedCart = await pricedResponse.json();
        const bottles = pricedCart.items.filter(item => String(item.variant_id) === variantInput.value);
        if (bottles.length !== 1 || bottles[0].quantity !== bottleQuantity || bottles[0].final_line_price !== Number(chosen.dataset.expectedPrice) ||
          String(bottles[0].selling_plan_allocation?.selling_plan?.id) !== planInput.value) throw new Error(submit.dataset.errorLabel);
        const programs = pricedCart.items.filter(item => String(item.variant_id) === cartForm.dataset.programVariant);
        if (programs.length !== 1 || programs[0].quantity !== 1 || programs[0].final_line_price !== 0 ||
          String(programs[0].selling_plan_allocation?.selling_plan?.id) !== cartForm.dataset.programPlan) throw new Error(submit.dataset.errorLabel);
        for (const id of giftIds) {
          const gifts = pricedCart.items.filter(item => String(item.variant_id) === id);
          if (gifts.length !== 1 || gifts[0].quantity !== 1 || gifts[0].final_line_price !== 0 || gifts[0].selling_plan_allocation) throw new Error(submit.dataset.errorLabel);
        }
        window.location.assign(cartForm.dataset.checkoutUrl);
      } catch (error) {
        errorMessage.textContent = error.message || submit.dataset.errorLabel;
        errorMessage.hidden = false;
        adding = false;
        submit.removeAttribute('aria-busy');
        selectOffer();
      }
    });
    const sticky = root.querySelector('[data-nv-sticky]');
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
    }, { threshold: 0 });
    observer.observe(root.querySelector('.nv-hero'));
    root.nvDisconnect = () => { observer.disconnect(); clearInterval(saleTimer); };
    selectOffer();
  }
  const start = scope => scope.querySelectorAll('[data-nv-product]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-nv-product]').forEach(root => root.nvDisconnect?.()));
})();
